import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=4cc657f9"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=4cc657f9&prod&lang=css"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=4cc657f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports